module.exports = __webpack_public_path__ + "media/huskie.c0e7abc6.webm";